import { render } from "./RowsIcon.vue?vue&type=template&id=588b835a"
import script from "./RowsIcon.vue?vue&type=script&lang=js"
export * from "./RowsIcon.vue?vue&type=script&lang=js"
script.render = render

export default script